import { useState, useEffect } from 'react';
import { Activity, Cpu, HardDrive, Wifi } from 'lucide-react';

const SystemStatus = () => {
  const [stats, setStats] = useState({
    cpu: 0,
    memory: 0,
    network: 0,
    threats: 0
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setStats({
        cpu: Math.floor(Math.random() * 30) + 45,
        memory: Math.floor(Math.random() * 20) + 60,
        network: Math.floor(Math.random() * 40) + 30,
        threats: Math.floor(Math.random() * 5)
      });
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const metrics = [
    { label: 'CPU Usage', value: stats.cpu, icon: <Cpu className="w-4 h-4" />, color: 'neon-green' },
    { label: 'Memory', value: stats.memory, icon: <HardDrive className="w-4 h-4" />, color: 'neon-cyan' },
    { label: 'Network', value: stats.network, icon: <Wifi className="w-4 h-4" />, color: 'neon-purple' },
    { label: 'Threats Blocked', value: stats.threats, icon: <Activity className="w-4 h-4" />, color: 'neon-red', suffix: '' }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="system-status">
      {metrics.map((metric, index) => (
        <div 
          key={index}
          className="bg-[hsl(var(--cyber-darker))] border border-[hsl(var(--border))] p-4 hover:border-[hsl(var(--${metric.color}))] transition-all"
          data-testid={`metric-${index}`}
        >
          <div className="flex items-center gap-2 mb-2">
            <div className={`text-[hsl(var(--${metric.color}))]`}>
              {metric.icon}
            </div>
            <span className="font-mono text-xs text-[hsl(var(--muted-foreground))]">
              {metric.label}
            </span>
          </div>
          <div className={`font-mono text-2xl font-bold text-[hsl(var(--${metric.color}))]`}>
            {metric.value}{metric.suffix !== undefined ? metric.suffix : '%'}
          </div>
          <div className="mt-2 h-1 bg-[hsl(var(--muted))] overflow-hidden">
            <div 
              className={`h-full bg-[hsl(var(--${metric.color}))] transition-all duration-500`}
              style={{ width: `${metric.suffix !== undefined ? (metric.value * 10) : metric.value}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default SystemStatus;
